var _g, _polygon, _polygon2, _path, _ellipse, _polygon3, _ellipse2, _ellipse3, _polygon4, _polygon5, _polygon6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoUeberdruckGrau(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    enableBackground: "new 0 0 48 48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 6.002,
    y: 0.166,
    width: 39.33,
    height: 47.834
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_2_)",
    fill: "#C6C6C6",
    points: "44.501,30.751 39.678,25.93 34.139,31.471 28.6,25.93 23.774,30.751  29.313,36.294 23.774,41.834 28.6,46.658 34.139,41.119 39.678,46.658 44.501,41.834 38.962,36.294  "
  }))))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#C6C6C6",
    points: "21.261,5.813 24.896,7.854 23.577,10.074 19.943,8.034 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#C6C6C6",
    points: "28.193,2.369 27.125,10.4 33.74,5.486 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C6C6C6",
    d: "M28.031,3.598c-0.154-1.769,1.191-3.333,3.008-3.491c1.814-0.159,3.412,1.146,3.566,2.916 c0.156,1.77-1.19,3.333-3.006,3.492C29.784,6.674,28.188,5.368,28.031,3.598z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.0866 0.9962 -0.9962 0.0866 31.9065 -28.1788)",
    fill: "#FFFFFF",
    cx: 31.321,
    cy: 3.311,
    rx: 1.573,
    ry: 1.615
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#C6C6C6",
    points: "4.276,42.621 10.891,37.707 9.823,45.738 "
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.0873 0.9962 -0.9962 0.0873 50.7079 34.2189)",
    fill: "#C6C6C6",
    cx: 6.68,
    cy: 44.782,
    rx: 3.216,
    ry: 3.298
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.0869 0.9962 -0.9962 0.0869 50.714 34.2435)",
    fill: "#FFFFFF",
    cx: 6.676,
    cy: 44.788,
    rx: 1.573,
    ry: 1.613
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#C6C6C6",
    points: "15.991,14.692 19.623,16.733 18.305,18.954 14.672,16.914 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#C6C6C6",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    points: "10.463,31.092 16.979,34.75 12.487,42.318 5.973,38.662  "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#C6C6C6",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    points: "26.059,6.182 31.359,9.159 16.127,34.82 10.827,31.843 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoUeberdruckGrau);
export default __webpack_public_path__ + "static/media/noUeberdruck_Grau.e9cf1efdbad835728f5c8f3f3b4d9110.svg";
export { ForwardRef as ReactComponent };